import axios from "axios";
//GET ALL CARCATAGORY BY COUNTRY
export const SEND_INVOICE_SMS = "SEND_INVOICE_SMS";
export const SEND_INVOICE_SMS_LOADING =
"SEND_INVOICE_SMS_LOADING";
export const SEND_INVOICE_SMS_LOADING_FAILED =
"SEND_INVOICE_SMS_LOADING_FAILED";

// HELPER ACTIONS CREATORS
//************************************** /

export const sendSMSInvoiceLoading = ms => ({
    type: SEND_INVOICE_SMS_LOADING,
    payload: ms
    });
    
    export const sendSMSInvoiceLoadingFailed = ms => ({
    type: SEND_INVOICE_SMS_LOADING_FAILED,
    payload: ms
    });

// RIDER PHINE NUBER
export function sendSMSInvoice(obj,handleSendInvoicesmsSuccess) {
  /* ${process.env.REACT_APP_FILE}/accountRoutes/api/v1/caseQuotations/getCountOfQuotation  */
    const request = axios.post(
      `${process.env.REACT_APP_FILE}/accountRoutes/api/v1/caseInvoices/sendInvoiceLinkOnNumber`,obj,
      {
        headers: { 'Authorization': 'bearer ' +localStorage.accountantToken}
      });

    return dispatch => {

    dispatch(sendSMSInvoiceLoading());
 
    request
    .then(response => {   
      console.log(response,"response, cancel invoice")   
    if (response.status == 200) {
    dispatch({
    type: SEND_INVOICE_SMS,
    payload: response.data
    });
  if(handleSendInvoicesmsSuccess){
    handleSendInvoicesmsSuccess()
  }
    } else {
      
    throw new Error(JSON.stringify(response.data.response.msg));
    }
    })
    .catch(error => {
        
    if (error.response) {
    if (error.response.status == "404") {
        console.log(error.response)
    dispatch(
        sendSMSInvoiceLoadingFailed(error.response.data.message)
    );
    } else {
    dispatch(sendSMSInvoiceLoadingFailed(error.response.data.message));
    }
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    } else if (error.request) {
    /*
    * The request was made but no response was received, `error.request`
    * is an instance of XMLHttpRequest in the browser and an instance
    * of http.ClientRequest in Node.js
    */
    dispatch(sendSMSInvoiceLoadingFailed(error.request));
    
    console.log(error.request);
    } else {
    // Something happened in setting up the request and triggered an Error
    console.log("Error", error.message);
    dispatch(sendSMSInvoiceLoadingFailed(error.message));
    }
    console.log(error);
    });
    };
    }


